import {getRoot, types} from "mobx-state-tree"
import PlayerConfig from "./PlayerConfig";
import {values} from "mobx";


const Player = types.model('Player', {
    id: types.identifierNumber,
    title: types.optional(types.string, ''),
    slug: types.optional(types.string, ''),
    template: types.optional(types.string, ''),
    is_published: types.optional(types.boolean, true),
    config: types.optional(PlayerConfig, () => PlayerConfig.create()),
}).actions(self => ({

    setTitle(value) {
        self.title = value
    },

    setSlug(value) {
        self.slug = value
    },

    setTemplate(value) {
        self.template = value
    },

    setIsPublished(value) {
        self.is_published = value
    },

})).views(self => ({

    get serialized() {
        return {
            id: self.id,
            title: self.title,
            slug: self.slug,
            template: self.selectedTemplate,
            is_published: self.is_published,
            config: self.config.serialized,
        }
    },

    get selectedTemplate() {
        return self.template || values(getRoot(self).entityStore.templates)[0]?.name
    },

    get isValid() {
        return !!self.title && !!self.slug && !!self.selectedTemplate && self.config.isValid
    },


}))

export default Player
